import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import './plugins/element.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
// import VueCookies from "vue-cookies";
// Vue.use(VueCookies);
Vue.use(VueI18n)
Vue.use(ElementUI)

// 导入挂载axios
Vue.prototype.$http = axios
// 配置请求根路径
// axios.defaults.baseURL = 'http://10.192.1.104:5522'
// axios.defaults.baseURL = 'http://139.198.187.39:8080'
// 请求头里面带一个token
axios.interceptors.request.use((config) => {
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  config.headers['asdf'] = 'asdf'
  config.headers['Authorization'] = window.sessionStorage.getItem('Authorization')
  return config;
});

Vue.config.productionTip = false

let lang = window.sessionStorage.getItem("lang");
lang = (lang == '' || lang == null? 'zh': lang);
// 创建i18n实例 
const i18n = new VueI18n({
  // 这是设置语言包，默认语言，
  locale: lang,
  messages: {
    //这是对应语言的语言文件所在 
    'en': require('/src/assets/language/en.json'),
    'zh': require('/src/assets/language/zh-cn.json')
  }
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
